import React from "react";
import { Paper } from "@mantine/core";
import AccountForm from "../components/AccountForm";
import { useNavigate } from "react-router-dom";
import StyledPageTitle from "../components/StyledPageTitle";

const AccountsCreatePage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <StyledPageTitle mb="sm">Create Account</StyledPageTitle>
      <Paper>
        <AccountForm onSubmit={(id) => navigate(`/app/accounts/${id}`)} />
      </Paper>
    </>
  );
};

export default AccountsCreatePage;
